import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {global} from "../../globals";
import {Project} from "../types/sherpa";
import {AdminService} from "../services/data/admin.service";

@Injectable({
	providedIn: 'root'
})
export class ProjectsResolver implements Resolve<Project[]> {

	constructor(private projectsService: AdminService) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Project[]> {
		global.enableLoader();
		return this.projectsService.getProjects();
	}
}

